import React from "react";
import SelectSearch from "react-select-search";
import './custom-select-search.css';

interface SelectInputProps {
    options: { value: string; name: string }[];
    value?: string;
    placeholder?: string;
    disabled?: boolean;
    classes?: string;
    onChange: (value: string) => void;
}

const SelectInput: React.FC<SelectInputProps> = ({
    options,
    value,
    disabled,
    classes,
    onChange,
    placeholder
}) => {
    const handleChange = (selectedOption: any) => {
        onChange(selectedOption);
    };

    return (
        <div className={`w-full  ${classes}`}>
            <SelectSearch
                options={options}
                value={value}
                disabled={disabled}
                onChange={handleChange}
                search
                placeholder={placeholder}
            />
        </div>
    );
};

export default SelectInput;
